import mqtt from 'mqtt';

export const getClient = (WS_URL: string, port: number) => {
  return mqtt.connect(`wss://${WS_URL}:8443`, {
    protocol: 'wss',
  });
};
